export default __webpack_public_path__ + "static/finance-blog-resource-img-3eec442af1b8e31b0b49283db4663809.png";